<template>
	<div class="navbar">
		<div class="logo">
			<img src="@/assets/homei_03.jpg" />
			<span>企业端</span>
		</div>
		<el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="rgba(0,0,0,0)" text-color="#fff" active-text-color="#fff">
			<el-menu-item index="1" >
				<img src="@/assets/home2s.png"/>
				<span slot="title"><router-link to="/home">数据统计</router-link></span>
			</el-menu-item>
			<el-submenu index="2">
				<template slot="title">
					<img src="@/assets/home3.png"/>
				<span slot="title">招聘管理</span>
				</template>
				<el-menu-item-group>
					<el-menu-item index="2-1"><router-link to="/home">广告栏目管理</router-link></el-menu-item>
					<el-menu-item index="2-2"><router-link to="/home">企业信息审核</router-link></el-menu-item>
					<el-menu-item index="2-3"><router-link to="/enterprise_manage">企业管理</router-link></el-menu-item>
					<el-menu-item index="2-4"><router-link to="/vip_manage">会员管理</router-link></el-menu-item>
					<el-menu-item index="2-5"><router-link to="/user_rencai">求职者管理</router-link></el-menu-item>
					<el-menu-item index="2-6"><router-link to="/home">简历库</router-link></el-menu-item>
					<el-menu-item index="2-7"><router-link to="/post_manage">岗位管理</router-link></el-menu-item>
					<el-menu-item index="2-8"><router-link to="/home">留言审核</router-link></el-menu-item>
					<el-menu-item index="2-9"><router-link to="/home">工作人员管理</router-link></el-menu-item>
					<el-menu-item index="2-10"><router-link to="/user_hr">HR管理</router-link></el-menu-item>
				</el-menu-item-group>
			</el-submenu>
			<el-menu-item index="3" >
				<img src="@/assets/home4.png"/>
				<span slot="title"><router-link to="/find">系统管理</router-link></span>
			</el-menu-item>
		</el-menu>
	</div>
</template>

<script>
	export default {
		name: 'navbars',
		data() {
			return {
				handleOpen(key, keyPath) {
					console.log(key, keyPath);
				},
				handleClose(key, keyPath) {
					console.log(key, keyPath);
				}
			}
		},
	}
</script>

<style lang="less" scoped>
a{
	color: #fff;
	height: 100%;
	display: inline-flex;
	width: 100%;
	align-items: center;
	
}
	.navbar {
		width: 245px;
		height: 100vw;
		position: fixed;
		z-index: 99991;
		left: 0;
		top: 0;
		background: #007CC4;
		padding-top: 55px;
	}
	
	.navbar .logo {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 105px;
	}
	
	.navbar .logo img {
		width: 132px;
		margin-right: 10px;
	}
	
	.navbar .logo span {
		display: inline-flex;
		align-items: center;
		padding: 0 13px;
		font-size: 12px;
		color: #CCD4EB;
		height: 19px;
		border-radius: 4px;
		border: 1px solid #CCD4EB;
	}
</style>


// WEBPACK FOOTER //
// src/components/navbars.vue